export default {"src":"/_next/static/media/logo-medienecke.e2a684d5.svg","height":1080,"width":1920,"blurWidth":0,"blurHeight":0};